import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AuditLogEntry } from "../domain/audit-log.types";

export type AuditLogStatus = "idle" | "loading" | "succeeded" | "failed";

export interface AuditLogState {
  entries: AuditLogEntry[];
  status: AuditLogStatus;
  error: string | null;
}

const initialState: AuditLogState = {
  entries: [],
  status: "idle",
  error: null,
};

const auditLogSlice = createSlice({
  name: "auditLog",
  initialState,
  reducers: {
    auditLogRequestStarted(state) {
      state.status = "loading";
      state.error = null;
    },
    auditLogLoaded(state, action: PayloadAction<AuditLogEntry[]>) {
      state.entries = action.payload;
      state.status = "succeeded";
    },
    auditLogRequestFailed(state, action: PayloadAction<string>) {
      state.status = "failed";
      state.error = action.payload;
    },
  },
});

export const { auditLogRequestStarted, auditLogLoaded, auditLogRequestFailed } =
  auditLogSlice.actions;

export default auditLogSlice.reducer;
